import axios from 'axios';
import { baseUrl, token } from '../../../../services/Apis';

export const entHorariosClasesApi = `${baseUrl}/entidad-horarios-clases`;

export const allEntHorarioClasesService = async (params) => {
  const res = await axios.get(entHorariosClasesApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveEntHorarioClasesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${entHorariosClasesApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(entHorariosClasesApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneEntHorarioClasesService = async (id) => {
  const res = await axios.get(`${entHorariosClasesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteEntHorarioClasesService = async (id) => {
  const res = await axios.delete(`${entHorariosClasesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
